// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261105/js/" + chunkId + "." + {"44":"67f71d28","225":"5c5b5e01","481":"c12b66fd","486":"c5748f68","770":"c8e79011"}[chunkId] + ".0.23063093467878715.chunk.js";
};